var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.isLoading
        ? _c("SuitableResourcesPlaceholder")
        : _vm.resourcesExist
        ? _c("ItemChipsWithMore", {
            attrs: {
              items: _vm.suitableContractors,
              moreNumber: _vm.resourcesCount,
              limit: _vm.limit,
              isPerson: "",
            },
            on: { showModal: _vm.showModal },
            scopedSlots: _vm._u([
              {
                key: "item",
                fn: function ({ highlighted, itemName }) {
                  return [
                    highlighted
                      ? _c(
                          "span",
                          {
                            staticClass:
                              "truncate text-storm-gray text-sm font-medium bg-white",
                          },
                          [_vm._v(" " + _vm._s(itemName) + " ")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          })
        : _vm._e(),
      !_vm.resourcesExist
        ? _c(
            "RouterLink",
            { attrs: { to: `/company_database/contractors/` } },
            [
              _c(
                "p",
                {
                  staticClass:
                    "text-sm text-notification-blue leading-normal font-400",
                  class: _vm.isMinHeight,
                },
                [_vm._v(" Go to Talent Directory ")]
              ),
            ]
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "flex flex-col bg-white" },
        [
          _vm.showAllResources
            ? _c("SuggestedResourcesModal", {
                attrs: {
                  name: this.name,
                  skillIds: _vm.skillIds,
                  visitId: _vm.visitId,
                  suitableContractors: _vm.suitableContractors,
                },
                on: {
                  activityUpdated: _vm.activityUpdated,
                  close: _vm.hideTooltip,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }